const riot = require('riot');

riot.tag2('page-note-print', '<div class="p24"> <div data-is="atom-markdown" content="{content}"></div> </div>', 'page-note-print,[data-is="page-note-print"]{display:block;background-color:white} page-note-print img,[data-is="page-note-print"] img{max-width:60%;height:auto}', '', function(opts) {
    this.preload = ({req, res}) => {
      return {
        workspace_id: req.params.workspace_id,
        project_id: req.params.project_id,
        note_id: req.params.note_id,
      };
    };

    this.on('show', async ({req, res}) => {
      await app.store.setup(req.params);
      let note = app.store.doc(`workspaces/${this.workspace_id}/projects/${this.project_id}/notes/${this.note_id}`);
      await note.fetch();
      this.content = note.data.content;

      document.title = note.getTitle();
      this.update();

      let images = Array.from(this.root.querySelectorAll('img'));
      await Promise.all(images.map(img => {
        if (img.complete) return;
        return new Promise(resolve => {
          img.onload = resolve;
          img.onerror = resolve;
        });
      }));
      window.print();
      window.close();
    });
});